import { HppdSeparationType } from "./models";

/** What "Separate HPPD" being on means: by job under job management, by role otherwise. */
export const hppdSeparationDimension = (jobManagementEnabled: boolean): HppdSeparationType =>
	jobManagementEnabled ? HppdSeparationType.Jobs : HppdSeparationType.Role;

/**
 * HPPD separation is a single on/off choice in the settings menu. A value saved by the older four-way
 * switch (Role / Role Groups / Jobs) is read as "on" for whichever dimension applies now; "None" stays
 * off. Anything else is not a value the app ever wrote, so it fails loudly instead of reading as "on".
 */
export const normalizeHppdSeparation = (saved: HppdSeparationType, jobManagementEnabled: boolean): HppdSeparationType => {
	switch (saved) {
		case HppdSeparationType.None:
			return HppdSeparationType.None;
		case HppdSeparationType.Role:
		case HppdSeparationType.RoleGroups:
		case HppdSeparationType.Jobs:
			return hppdSeparationDimension(jobManagementEnabled);
		default:
			throw new Error(`Unknown hppd_separation_type "${saved}"`);
	}
};

/** The value the "Separate HPPD" checkbox saves when clicked from `current`. */
export const toggleHppdSeparation = (current: HppdSeparationType, jobManagementEnabled: boolean): HppdSeparationType =>
	current === HppdSeparationType.None ? hppdSeparationDimension(jobManagementEnabled) : HppdSeparationType.None;

/** i18n key of the checkbox label, naming the dimension "on" splits by. */
export const hppdSeparationLabelKey = (jobManagementEnabled: boolean): "separate.hppd.by.job" | "separate.hppd.by.role" =>
	jobManagementEnabled ? "separate.hppd.by.job" : "separate.hppd.by.role";
